import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.css";

const VaporCheckbox = ({ checked, disabled, label, onChange, style, styleIcon }) => {
  return (
    <label className="vapor-checkbox" style={style}>
      <input type="checkbox" checked={checked} disabled={disabled} onChange={onChange} />
      <span className="vapor-form_checkbox">
        <FontAwesomeIcon
          icon={["fas", "check"]}
          style={styleIcon}
        />
      </span>
      <span className="vapor-form_labeltxt">{label}</span>
    </label>
  );
};

VaporCheckbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object
};

VaporCheckbox.defaultProps = {
  checked: false,
  disabled: false,
  label: "",
  onChange: () => { },
  style: {},
  styleIcon: {color:"white", fontSize: "0.8rem"}
};

export default VaporCheckbox;
